import { Button, Group, Stack, TextInput } from '@mantine/core';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useCreateAssetForm } from 'src/Hooks/Forms/useCreateAssetForm';
import { useCreateAsset } from 'src/Hooks/Mutations/useCreateAsset';

import AddressAutocomplete from '../../Shared/AddressAutocomplete/AddressAutocomplete.component';

import styles from './OnboardingAssetInfoForm.module.scss';
import { Props } from './OnboardingAssetInfoForm.types';

// t('onboarding.type.REAL_ESTATE', 'Immobilier')
// t('onboarding.type.MOVABLE', 'Mobilier')
// t('onboarding.type.FINANCIAL', 'Financier')
// t('onboarding.type.INTELLECTUAL', 'Intellectuel')
// t('onboarding.type.BUSINESS', 'Entreprise')

const OnboardingAssetInfoForm = ({ onCreate, goToPreviousStep, subType }: Props) => {
  const { t } = useTranslation();
  const form = useCreateAssetForm({ subType });
  const { mutate, isLoading } = useCreateAsset({ onSuccess: data => onCreate(data.id) });

  return (
    <form onSubmit={form.onSubmit(values => mutate(values))} className={styles.container}>
      <p className={styles.title}>{t('onboarding.firstAssetDetails', 'Détails de votre bien')}</p>
      <p className={styles.description}>
        {t('onboarding.fillAssetInfo', 'Remplissez les détails administratifs de votre bien')}
      </p>
      <Stack gap={12}>
        <TextInput
          placeholder={t('onboarding.typeName', 'Entrez le nom de votre bien')}
          description={t('onboarding.nameDescription', 'Nom')}
          {...form.getInputProps('name')}
        />
        <AddressAutocomplete
          {...form.getInputProps('placeId')}
          placeholder={t('onboarding.typeBillingAddress', "Entrez l'adresse du bien")}
          description={t('onboarding.billingAddressDescription', 'Adresse')}
        />
      </Stack>
      <Group justify={'space-between'} className={styles.actions}>
        <Button
          leftSection={<IconArrowLeft height={18} />}
          variant={'outline'}
          onClick={() => goToPreviousStep()}
        >
          {t('onboarding.previous', 'Précédent')}
        </Button>
        <Button
          rightSection={<IconArrowRight color={'white'} height={18} />}
          loading={isLoading}
          type={'submit'}
        >
          {t('onboarding.next', 'Suivant')}
        </Button>
      </Group>
    </form>
  );
};

export default OnboardingAssetInfoForm;
